import { CaseDocumentStatus, DocumentChecklist, DocumentChecklistItem } from "./DocumentChecklist";

const BASE_TYPE_PIECE_CODES = [
  "STATUTS",
  "RCCM",
  "PIECE_IDENTITE_RL",
  "NOMINATION_DIRIGEANTS",
  "DECLARATION_BENEFICIAIRES_EFFECTIFS",
];

// Use explicit branching to avoid dynamic object access patterns flagged by detect-object-injection.
function getLegalFormSpecificTypePieceCodes(legalForm: string): string[] {
  switch (legalForm) {
    case "GIE":
      return ["CONVENTION_GIE"];
    case "ASSOCIATION":
      return ["RECEPISSE_DECLARATION"];
    default:
      return [];
  }
}

function buildItem(
  businessKey: string,
  typePieceCode: string,
  statut: CaseDocumentStatus,
): DocumentChecklistItem {
  return {
    caseDocumentId: `${businessKey}-${typePieceCode}`,
    typePieceCode,
    obligation: "REQUIRED",
    quantiteAttendue: 1,
    baseReglementaire: "Acte uniforme OHADA relatif au droit des sociétés commerciales",
    statut,
    satisfaite: statut === "VALIDE",
  };
}

/**
 * Repli local pour le développement (`VITE_USE_MOCK_KYB_ENTITY=true`) : le vrai endpoint (#25196)
 * est livré, ce mock ne sert plus qu'à travailler hors backend. Sans forme juridique, les règles ne
 * peuvent pas être évaluées — reporté comme non déterminé, jamais comme « rien n'est requis »
 * (cf. bug #25470).
 */
export function generateMockDocumentChecklist(
  businessKey: string,
  legalForm: string,
  _incorporationCountry: string,
): DocumentChecklist {
  if (!legalForm) {
    return {
      businessKey,
      determine: false,
      complet: false,
      tauxCompletude: 0,
      pieces: [],
    };
  }

  const typePieceCodes = [
    ...BASE_TYPE_PIECE_CODES,
    ...getLegalFormSpecificTypePieceCodes(legalForm),
  ];
  const pieces = typePieceCodes.map((code) => buildItem(businessKey, code, "ATTENDUE"));
  return {
    businessKey,
    determine: true,
    complet: false,
    tauxCompletude: 0,
    pieces,
  };
}
